(function(){

  var LOGO_URL = 'https://cdn.shopify.com/s/files/1/0953/0156/6737/files/LOGO_MMASSUCI_PRETA_63f506a9-5197-40a4-9d08-15fa2d93a560.png?v=1781093203';

  var btn = document.getElementById('mm-orc-btn');
  if (!btn) { console.error('[MM] botão não encontrado'); return; }

  var dataEl = document.getElementById('mm-orcamento-data');
  if (!dataEl) { console.error('[MM] dados não encontrados'); return; }

  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); }
  catch (e) { console.error('[MM] JSON inválido:', e); return; }

  console.log('[MM Orçamento] carregado —', DATA.produto);

  function brl(n) {
    if (n == null || n === '') return null;
    if (typeof n === 'object' && n.amount) n = n.amount;
    var s = String(n);
    var num = s.indexOf(',') > -1
      ? parseFloat(s.replace(/\./g, '').replace(',', '.'))
      : parseFloat(s.replace(/[^\d.]/g, ''));
    if (isNaN(num)) return null;
    return num.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function fmt(v) {
    if (v == null) return null;
    if (Array.isArray(v)) return v.filter(Boolean).join(', ') || null;
    var s = String(v).trim();
    return s || null;
  }

  function varianteSelecionada() {
    var form = document.querySelector('form[action*="/cart/add"]');
    var id = form && form.querySelector('[name="id"]')
      ? form.querySelector('[name="id"]').value : null;
    if (!id) { var u = new URLSearchParams(location.search); id = u.get('variant'); }
    return DATA.variantes.find(function(v) { return String(v.id) === String(id); })
      || DATA.variantes[0] || {};
  }

  function row(label, valor) {
    var v = fmt(valor);
    return v
      ? '<div class="row"><span class="k">' + label + '</span><span class="v">' + v + '</span></div>'
      : '';
  }

  /* ---------- CSS: fundo branco, Inter, fit para A4 ---------- */
  function getCSS() {
    return ''
      + '*{margin:0;padding:0;box-sizing:border-box}'
      + '@page{size:A4;margin:0}'
      + 'html,body{background:#FFFFFF;font-family:"Inter",system-ui,sans-serif;'
      +   '-webkit-print-color-adjust:exact;print-color-adjust:exact}'

      + '.sheet{'
      +   'width:210mm;min-height:297mm;background:#FFFFFF;color:#1D1B18;'
      +   'padding:18mm 20mm 14mm;'
      +   'display:flex;flex-direction:column'
      + '}'
      + '.content{flex:1}'

      + '.head{'
      +   'display:flex;justify-content:space-between;align-items:flex-end;'
      +   'padding-bottom:9px;border-bottom:1px solid #1D1B18'
      + '}'
      + '.logo-wrap{display:flex;flex-direction:column;gap:5px}'
      + '.logo-wrap img{height:28px;width:auto;object-fit:contain;display:block}'
      + '.at{font-size:11px;color:#7A756D;letter-spacing:.02em}'
      + '.dt{'
      +   'text-align:right;font-size:7.5px;font-weight:500;letter-spacing:.2em;'
      +   'text-transform:uppercase;color:#7A756D;line-height:1.6'
      + '}'

      + '.hero{display:grid;grid-template-columns:1fr 1.1fr;gap:14mm;margin-top:9mm}'
      + '.frame{'
      +   'width:100%;height:64mm;background:#F4F2EE;border:1px solid #EAE6DF;'
      +   'overflow:hidden;display:flex;align-items:center;justify-content:center'
      + '}'
      + '.frame img.product{width:100%;height:100%;object-fit:cover;display:block}'
      + '.intro{align-self:center}'
      + '.eb{'
      +   'font-size:8.5px;font-weight:600;letter-spacing:.26em;'
      +   'text-transform:uppercase;color:#A0896A'
      + '}'
      + '.pn{'
      +   'font-family:"Inter",system-ui,sans-serif;font-weight:300;'
      +   'font-size:34px;line-height:1.1;margin:10px 0 0;color:#1D1B18'
      + '}'

      + '.sl{'
      +   'font-size:8px;font-weight:600;letter-spacing:.24em;text-transform:uppercase;'
      +   'color:#7A756D;margin:9mm 0 5px;display:flex;align-items:center;gap:10px'
      + '}'
      + '.sl::after{content:"";flex:1;height:1px;background:#EAE6DF}'

      + '.specs{display:grid;grid-template-columns:1fr 1fr;column-gap:14mm}'
      + '.row{'
      +   'display:flex;justify-content:space-between;gap:10px;padding:6px 0;'
      +   'border-bottom:1px solid #EAE6DF;align-items:baseline'
      + '}'
      + '.k{'
      +   'font-size:8.5px;font-weight:500;letter-spacing:.08em;text-transform:uppercase;'
      +   'color:#7A756D;white-space:nowrap;flex-shrink:0'
      + '}'
      + '.v{font-size:13.5px;text-align:right;color:#1D1B18;overflow-wrap:break-word;font-weight:400}'

      + '.vars{'
      +   'display:grid;grid-template-columns:1fr 1fr;gap:4px 14mm;'
      +   'padding:6px 0 10px;border-bottom:1px solid #EAE6DF'
      + '}'
      + '.vitem{font-size:12.5px;color:#1D1B18;line-height:1.5;font-weight:400}'

      + '.price{'
      +   'margin-top:9mm;display:flex;justify-content:space-between;align-items:flex-end;'
      +   'border-top:1px solid #1D1B18;padding-top:10px'
      + '}'
      + '.lab{'
      +   'font-size:8.5px;font-weight:600;letter-spacing:.24em;'
      +   'text-transform:uppercase;color:#7A756D'
      + '}'
      + '.val{font-weight:300;font-size:32px;line-height:1;margin-top:4px;color:#1D1B18}'
      + '.val small{font-size:15px;color:#7A756D;font-weight:400}'
      + '.pnote{'
      +   'font-size:10.5px;color:#7A756D;max-width:32ch;'
      +   'text-align:right;line-height:1.4;font-style:normal'
      + '}'

      + '.foot{margin-top:8mm;padding-top:8px;border-top:1px solid #EAE6DF}'
      + '.fl{'
      +   'display:flex;justify-content:space-between;font-size:8.5px;letter-spacing:.08em;'
      +   'color:#7A756D;text-transform:uppercase;margin-bottom:6px'
      + '}'
      + '.disc{font-size:9.5px;color:#A39C8E;line-height:1.4;font-style:normal}';
  }

  function getContent() {
    var v     = varianteSelecionada();
    var d     = DATA;
    var mes   = new Date()
                  .toLocaleDateString('pt-BR', { month: '2-digit', year: 'numeric' })
                  .replace('/', '\u00a0\u00b7\u00a0');
    var preco  = brl(d.preco_ref) || brl(d.preco_min);
    var imgTag = d.imagem ? '<img class="product" src="' + d.imagem + '" alt="">' : '';

    var varTitulos = DATA.variantes
      .map(function(vv) { return fmt(vv.titulo); })
      .filter(Boolean);
    var varsHtml = varTitulos.length
      ? '<div class="sl">Variantes dispon\u00edveis</div>'
      +   '<div class="vars">'
      +     varTitulos.map(function(t) { return '<span class="vitem">' + t + '</span>'; }).join('')
      +   '</div>'
      : '';

    /* Disclaimer único: só no rodapé. A nota junto ao preço foi removida
       para não duplicar a mesma informação em dois lugares da ficha. */
    var priceBlock = preco
      ? '<div class="price">'
      +   '<div>'
      +     '<div class="lab">A partir de</div>'
      +     '<div class="val"><small>R$\u00a0</small>' + preco + '</div>'
      +   '</div>'
      + '</div>'
      : '';

    return '<div class="sheet">'

      + '<div class="content">'

      + '<header class="head">'
      +   '<div class="logo-wrap">'
      +     '<img src="' + LOGO_URL + '" alt="MMASSUCI">'
      +     '<div class="at">Ateli\u00ea de ilumina\u00e7\u00e3o</div>'
      +   '</div>'
      +   '<div class="dt">Ficha t\u00e9cnica<br>Or\u00e7amento de refer\u00eancia<br>'
      +   '<span style="color:#A0896A">' + mes + '</span></div>'
      + '</header>'

      + '<section class="hero">'
      +   '<div class="frame">' + imgTag + '</div>'
      +   '<div class="intro">'
      +     (fmt(d.linha) ? '<div class="eb">' + fmt(d.linha) + '</div>' : '')
      +     '<h1 class="pn">' + (d.produto || '') + '</h1>'
      +   '</div>'
      + '</section>'

      /* Ambiente removido conforme solicitado */
      + '<div class="sl">Produto</div>'
      + '<div class="specs">'
      +   row('C\u00f3digo',             d.codigo)
      +   row('Refer\u00eancia',         d.referencia)
      +   row('Estilo',                  d.estilo)
      +   row('Disposi\u00e7\u00e3o',    d.disposicao)
      +   row('Mat\u00e9ria\u2011prima', d.materia_prima)
      +   row('Acabamento',              d.acabamento)
      +   row('Lan\u00e7amento',         d.lancamento)
      +   row('Dimens\u00f5es',          v.dimensoes)
      +   row('Peso',                    v.peso)
      + '</div>'

      + '<div class="sl">T\u00e9cnico</div>'
      + '<div class="specs">'
      +   row('Soquete',                     d.soquete)
      +   row('Tens\u00e3o',                 d.tensao)
      +   row('Frequ\u00eancia',             d.frequencia)
      +   row('Consumo de energia',           d.consumo)
      +   row('Grau de prote\u00e7\u00e3o',  d.grau_protecao)
      +   row('Acess\u00f3rios',             d.acessorios)
      +   row('Prazo de produ\u00e7\u00e3o', d.prazo)
      + '</div>'

      + varsHtml
      + priceBlock

      + '</div>' /* /.content */

      + '<footer class="foot">'
      +   '<div class="fl">'
      +     '<span>Eusébio\u00a0\u00b7\u00a0Ceará</span>'
      +     '<span>mmassuci.com.br</span>'
      +   '</div>'
      +   '<p class="disc">Valores e prazos de refer\u00eancia, sujeitos a confirma\u00e7\u00e3o '
      +   'em proposta formal. Pe\u00e7as feitas sob encomenda; pequenas varia\u00e7\u00f5es '
      +   's\u00e3o pr\u00f3prias do trabalho manual.</p>'
      + '</footer>'

      + '</div>'; /* /.sheet */
  }

  function buildDoc() {
    var fonts = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap';
    return '<!DOCTYPE html><html lang="pt-BR"><head><meta charset="UTF-8">'
      + '<link href="' + fonts + '" rel="stylesheet">'
      + '<style>' + getCSS() + '</style>'
      + '</head><body>' + getContent() + '</body></html>';
  }

  function viaPrint() {
    var old = document.getElementById('mm-overlay');
    if (old) old.remove();

    var iframe = document.createElement('iframe');
    iframe.id = 'mm-overlay';
    iframe.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;border:none;z-index:2147483647;background:#FFFFFF';
    document.body.appendChild(iframe);

    var doc = iframe.contentDocument || iframe.contentWindow.document;
    doc.open(); doc.write(buildDoc()); doc.close();

    var go = function() {
      try {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      } catch(e) { console.error('[MM] print falhou:', e); }
      var cleanup = function() {
        if (iframe.parentNode) iframe.remove();
        try { iframe.contentWindow.removeEventListener('afterprint', cleanup); } catch(e) {}
      };
      try { iframe.contentWindow.addEventListener('afterprint', cleanup); } catch(e) {}
      setTimeout(cleanup, 10000);
    };

    if (doc.fonts && doc.fonts.ready) {
      doc.fonts.ready.then(function() { setTimeout(go, 400); });
    } else {
      setTimeout(go, 1000);
    }
  }

  btn.addEventListener('click', function() {
    var textoOrig = btn.textContent;
    btn.disabled  = true;
    btn.textContent = 'Gerando\u2026';
    viaPrint();
    setTimeout(function() {
      btn.disabled    = false;
      btn.textContent = textoOrig;
    }, 800);
  });

})();